import { Star, ArrowRight } from "lucide-react";

const REVIEWS = [
  { quote: "Excellent company and genuinely lovely guys. They know what they are doing and do it well. Couldn't fault a single thing.", name: "Chris", source: "Hitched" },
  { quote: "The service was perfect from start to finish. Complete professionalism but with a personal touch.", name: "Stephen", source: "Hitched" },
  { quote: "I would give the team more than 5 stars here if I could. I 1000% recommend.", name: "Michelle & Ken", source: "Bridebook" },
  { quote: "We honestly couldn't have asked for a better team to capture our special day. Absolutely incredible.", name: "Matthew", source: "Hitched" },
  { quote: "We received sneak peeks within a few days after the wedding. The team were unreal on the day.", name: "Paige", source: "Hitched" },
  { quote: "It honestly felt like just having more friends at the wedding than it did a photographer and videographer.", name: "Michelle", source: "Hitched" },
  { quote: "Alex and his incredible team could not have been any more genuine, professional and easy to work with.", name: "Lauren", source: "Facebook" },
  { quote: "From start to finish, our experience was exceptional. We felt completely at ease.", name: "Amber", source: "Hitched" },
  { quote: "We honestly don't even know where to begin with Alex and Amie. Absolutely incredible from start to finish.", name: "Sophie", source: "Hitched" },
  { quote: "They were absolutely amazing and captured our day perfectly. 100% recommend.", name: "Jessica", source: "Hitched" },
  { quote: "From our first meeting right through to the day itself, they were beginning-to-end amazing.", name: "Georgia", source: "Hitched" },
  { quote: "They really captured the essence of the love we have for each other. Our video is so magical.", name: "Ryan", source: "Hitched" },
  { quote: "If you are looking for a wedding videographer, this is who to book.", name: "Emma", source: "Hitched" },
  { quote: "Alex and Shannon were nothing short of brilliant.", name: "Emily", source: "Hitched" },
  { quote: "Wow wow wow. We are both over the moon with our video and cannot stop watching it.", name: "Jessie", source: "Facebook" },
  { quote: "An amazing wedding video, along with all the full cuts for the ceremony and speeches. Very professional.", name: "Raymond", source: "Hitched" },
];

function FiveStars({ keyPrefix, className }) {
  return (
    <>
      {[...Array(5)].map((_, s) => (
        <Star key={`${keyPrefix}-${s}`} className={className} strokeWidth={1} />
      ))}
    </>
  );
}

function ReviewCard({ review, index }) {
  return (
    <figure
      data-testid={`review-card-${index}`}
      className="w-[340px] shrink-0 mr-6 bg-white border border-[#E5E3DB] p-7 flex flex-col"
    >
      <div className="flex items-center gap-1 mb-4">
        <FiveStars keyPrefix={`card-${index}`} className="w-3 h-3 fill-[#A9927D] text-[#A9927D]" />
      </div>
      <blockquote className="font-display text-base leading-relaxed text-[#1F1E1D] italic mb-5">
        “{review.quote}”
      </blockquote>
      <figcaption className="mt-auto">
        <div className="text-sm font-medium text-[#1F1E1D]">{review.name}</div>
        <div className="flex items-center gap-1.5 text-[10px] tracking-overline uppercase text-[#8A8782] font-medium mt-1">
          <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 shrink-0" aria-hidden="true" data-testid="verified-tick">
            <path fill="#1D9BF0" d="M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81c-.66-1.31-1.91-2.19-3.34-2.19s-2.67.88-3.33 2.19c-1.4-.46-2.91-.2-3.92.81s-1.26 2.52-.8 3.91c-1.31.67-2.2 1.91-2.2 3.34s.89 2.67 2.2 3.34c-.46 1.39-.21 2.9.8 3.91s2.52 1.26 3.91.81c.67 1.31 1.91 2.19 3.34 2.19s2.68-.88 3.34-2.19c1.39.45 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.67 2.19-1.91 2.19-3.34zm-11.71 4.2L6.8 12.46l1.41-1.42 2.26 2.26 4.8-5.23 1.47 1.36-6.2 6.77z" />
          </svg>
          Verified on {review.source}
        </div>
      </figcaption>
    </figure>
  );
}

export function ReviewsSection() {
  return (
    <section
      data-testid="reviews-section" data-track-section="reviews"
      className="px-6 md:px-12 lg:px-16 py-24 md:py-32"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14 md:mb-16">
          <div className="flex items-center justify-center gap-1.5 mb-6">
            <FiveStars keyPrefix="hdr" className="w-6 h-6 fill-[#A9927D] text-[#A9927D]" />
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight text-[#1F1E1D] mb-4">
            400+ five-star reviews.
          </h2>
          <p className="text-[#5C5A56] max-w-xl mx-auto">
            Rated 5.0 from 403 verified reviews across Hitched, Google,
            Facebook and Bridebook, the most-reviewed wedding videographers
            and photographers in Essex.
          </p>
        </div>
        <div
          data-testid="reviews-marquee"
          className="relative overflow-hidden mb-14 marquee-mask"
        >
          <div className="flex w-max marquee-track">
            {[...REVIEWS, ...REVIEWS].map((r, i) => (
              <ReviewCard key={`${r.name}-${i}`} review={r} index={i} />
            ))}
          </div>
        </div>
        <div className="text-center">
          <a
            href="https://weddingvideoessexreviews.co.uk/"
            target="_blank"
            rel="noreferrer"
            data-testid="reviews-link" data-track-click="reviews-website"
            className="inline-flex items-center gap-2 text-xs tracking-overline uppercase text-[#2F2E2E] hover:text-[#A9927D] font-medium border-b border-[#2F2E2E] hover:border-[#A9927D] pb-1 group"
          >
            Read all 403 reviews
            <ArrowRight
              className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform"
              strokeWidth={1.5}
            />
          </a>
        </div>
      </div>
    </section>
  );
}
